// extracted by mini-css-extract-plugin
export default {"item":"item_item__McjyC","imgWrapper":"item_imgWrapper__AeVU4","body":"item_body__5I5Jv","left":"item_left__CeBpr","progress":"item_progress__iz-AJ"};